import type { ProductSpec } from '../lib/types';

interface SpecsTableProps {
  specs: ProductSpec[];
}

/**
 * Public-facing spec table rendered as a definition list for accessibility
 * and SEO. Falls back to nothing when empty so callers can blindly mount it.
 */
export default function SpecsTable({ specs }: SpecsTableProps) {
  if (!specs || specs.length === 0) return null;
  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
      <dl className="divide-y divide-slate-100">
        {specs.map((s, i) => (
          <div
            key={i}
            className="grid grid-cols-[10rem_1fr] gap-4 px-5 py-3.5 text-sm transition-colors odd:bg-slate-50/50 hover:bg-brand-50/40 md:grid-cols-[14rem_1fr]"
          >
            <dt className="font-semibold text-slate-500">{s.key}</dt>
            <dd className="font-medium text-slate-900">{s.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
